import { render, staticRenderFns } from "./carrierBookingAgentForm.vue?vue&type=template&id=057fddc9&"
import script from "./carrierBookingAgentForm.vue?vue&type=script&lang=js&"
export * from "./carrierBookingAgentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('057fddc9')) {
      api.createRecord('057fddc9', component.options)
    } else {
      api.reload('057fddc9', component.options)
    }
    module.hot.accept("./carrierBookingAgentForm.vue?vue&type=template&id=057fddc9&", function () {
      api.rerender('057fddc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/carrierBookingAgentForm.vue"
export default component.exports